import { render, staticRenderFns } from "./SuggestedSuccess.vue?vue&type=template&id=69ad49ba&scoped=true"
import script from "./SuggestedSuccess.vue?vue&type=script&lang=js"
export * from "./SuggestedSuccess.vue?vue&type=script&lang=js"
import style0 from "./SuggestedSuccess.vue?vue&type=style&index=0&id=69ad49ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ad49ba",
  null
  
)

export default component.exports